import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { WorkflowLanguageService } from '@services/workflow-language.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { debounceTime, Subscription } from 'rxjs';

@Component({
    selector: 'app-default-language-modal',
    templateUrl: './default-language-modal.component.html',
    styleUrls: ['./default-language-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DefaultLanguageModalComponent implements OnInit {

  onClose: EventEmitter<any> = new EventEmitter();

  @Input() headerTitle ?
  @Input() confirmButtonText ?
  @Input() workflowStatus ?
  @Input() isVideoFlow ?
  @Input() defaultWorkflowName ?

  name = new UntypedFormControl('New Workflow', Validators.required)
  filterLang = new UntypedFormControl()

  allLangs = []
  defaultLanguage
  defaultLanguageName

  workflowName
  filteredLangs = []
  subscriptions : Subscription[] = []

  constructor(
    private workflowLangService: WorkflowLanguageService, 
    public modalRef: BsModalRef,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    // Set workflow name from input if provided
    if (this.defaultWorkflowName) {
      this.name.setValue(this.defaultWorkflowName);
    }
    
    this.allLangs = this.workflowLangService.allLangs
    
    // Filter languages for video flow to show supported languages
    if(this.isVideoFlow) {
      const allowedVideoFlowLanguageCodes = [
        'af', 'sq', 'am', 'ar', 'hy', 'az', 'eu', 'bn', 'bs', 'bg', 'ca', 'zh-CN', 'zh-TW',
        'hr', 'cs', 'da', 'nl', 'en', 'et', 'tl', 'fi', 'fr', 'gl', 'ka', 'de', 'el', 'gu',
        'iw', 'hi', 'hu', 'is', 'id', 'ga', 'it', 'ja', 'jw', 'kn', 'kk', 'km', 'ko', 'lo',
        'lv', 'lt', 'mk', 'ms', 'ml', 'mt', 'mr', 'mn', 'my', 'ne', 'no', 'ps', 'fa', 'pl',
        'pt', 'pa', 'ro', 'ru', 'sr', 'si', 'sk', 'sl', 'so', 'es', 'sw', 'sv', 'ta', 'te',
        'th', 'tr', 'uk', 'ur', 'uz', 'vi', 'cy', 'zu'
      ];
      this.allLangs = this.allLangs.filter(lang => allowedVideoFlowLanguageCodes.includes(lang.code))
    }
    
    // Set default language to user's current interface language
    const currentInterfaceLang = this.translateService.getCurrentLang();
    const userLang = this.allLangs.find(lang => lang.code === currentInterfaceLang);
    if (userLang) {
      this.defaultLanguage = userLang.code;
      this.defaultLanguageName = userLang.name;
    }
    
    this.subscriptions.push(this.filterLang.valueChanges.pipe(debounceTime(300)).subscribe(res => {
      if (res) {
        this.filterLangs(res.toLowerCase());
      } else {
        this.filteredLangs = this.allLangs
      }
    }))
    this.filteredLangs = this.allLangs
  }

  stop(event) {
    event.stopPropagation()
  }

  filterLangs(lang) {
    let filteredData = []
    filteredData = this.allLangs.filter(langData => (langData.name.toLowerCase()).includes(lang.toLowerCase()))
    this.filteredLangs = filteredData;
  }

  close() {
    this.modalRef.hide()
  }

  selectDefaultLanguage(lang) {
    this.defaultLanguage = lang.code
    this.defaultLanguageName = lang.name
  }

  saveDefaultLanguage() {
    this.workflowName = this.name.value
    this.onClose.emit(true)
  }

}
